module.exports = __webpack_public_path__ + "img/cp5-2.b59af5f3.jpg";